import { FC, useEffect, useState } from 'react';
import { LandscapeIndicatorContributionAddTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchVerificationStatuses } from '../../../store/landscapeAPI/verificationStatus/reducers/verification-status.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { saveContribution } from '../../../store/landscapeAPI/value/reducers/contribution.slice';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import { ValueSaveRequestDto } from '../../../store/landscapeAPI/value/dto/request/value-save-request.dto';
import { useNavigate, useParams } from 'react-router-dom';
import { ValueType } from '../../../store/landscapeAPI/value/value-type';
import { DEFAULT_VERIFICATION_STATUS_ID, getUUID } from '../../../utils/UUID';

interface LandscapeIndicatorContributionAddPageProps {}

const LandscapeIndicatorContributionAddPage: FC<
  LandscapeIndicatorContributionAddPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id, landscapeIndicatorId } = useParams();

  const [contribution, setContribution] = useState<ValueResponseDto>({
    date: '',
    qty: null,
    qtyUnit: null,
    time: null,
    timeUnit: null,
    compactIndicatorId: landscapeIndicatorId!,
    valuesType: ValueType.Contribution,
    verificationStatusId: '',
    verificationStatus: null,
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { verificationStatuses, status } = useSelector(
    (state: RootState) => state.verificationStatusSlice
  );

  useEffect(() => {
    dispatch(fetchVerificationStatuses());
  }, [dispatch]);

  const handleOnChange = (contribution: ValueResponseDto) => {
    setContribution(contribution);
  };

  const callbackFn = async (contribution: ValueResponseDto) => {
    const contributionToSave: ValueSaveRequestDto = {
      indicatorId: '',
      qty: contribution.qty,
      qtyUnit: contribution.qtyUnit,
      time: contribution.time,
      timeUnit: contribution.timeUnit,
      compactId: id!,
      date: contribution.date,
      compactIndicatorId: landscapeIndicatorId!,
      verificationStatusId:
        contribution.verificationStatusId || DEFAULT_VERIFICATION_STATUS_ID,
      id: contribution.id,
      published: contribution.published,
    };
    await dispatch(saveContribution(contributionToSave));
    navigate(
      `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/contribution`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeIndicatorContributionAddTemplate
      verificationStatuses={verificationStatuses ?? []}
      contribution={contribution}
      handleOnChange={handleOnChange}
      callbackFn={callbackFn}
    />
  );
};

export default LandscapeIndicatorContributionAddPage;
